import { createContext } from 'react'

import { MobileDetectContextType } from './types'

export const MobileDetectContext = createContext<MobileDetectContextType | undefined>(undefined)
